function isBetween(value: number, [a, b]: [number, number]): boolean {
  return value > a && value < b
}

export { isBetween }
